import styled from "styled-components";
import { NoAccountsFilled } from '@assets';

export const RootContainer = styled.div`
  padding: 16px;

  @media screen and (max-width: 350px) {
    padding: 16px 8px;
  }
`;

export const ItemBox = styled.div`
padding: 8px;
margin-bottom: 11px;
display: flex;
align-items: center;
justify-content: flex-start;
gap: 12px;
border-radius: 12px;
border: 1px solid #DEDEDE;
background: #EFEFEF;
cursor: pointer;
`;

export const InfoBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 4px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 32px;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;

  .ant-btn-primary {
    width: ${props => props.fullWidth === 'true' ? '100%' : 'auto'} !important;
    height: 52px;
    padding-inline: 24px;
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
    flex-direction: row-reverse;
  }

  .ant-btn-icon {
    font-size: 18px;
    margin: 0 !important;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 60px;
  border-radius: ${(props) => (props.radius === "none" ? "none" : "12px")};
  object-fit: contain;

  @media screen and (max-width: 378px) {
    width: 45px;
  }
  @media screen and (max-width: 350px) {
    width: 35px;
  }
`;

export const Title = styled.div`
padding-bottom: 16px;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #808080;
`;

export const NumberText = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #101415;
  
  @media screen and (max-width: 378px) {
    font-size: 14px;
  }
  @media screen and (max-width: 310px) {
    font-size: 13px;
  }
`;

export const Text = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;

export const EmptyBox = styled.div`
margin-top: 25%;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 16px;

@media screen and (min-height: 800px) {
  margin-top: 35%;
}

@media screen and (min-height: 900px) {
  margin-top: 40%;
}
`;

export const EmptyIcon = styled(NoAccountsFilled)`
  width: 80px;
  height: 80px;

@media screen and (max-width: 375px) {
  width: 60px;
  height: 60px;
}
`;

export const EmptyText = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;